//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Returns actual application settings info.
 * @return Actual application settings info.
 */
export function settingsDto(config?: AxiosRequestConfig | undefined): Promise<Types.SettingsDto> {
    let url_ = getBaseUrl() + "/api/settings";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSettingsDto,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSettingsDto?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSettingsDto(_response);
    });
}

function processSettingsDto(response: AxiosResponse): Promise<Types.SettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSettingsDto(resultData200);
        return Promise.resolve<Types.SettingsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SettingsDto>(null as any);
}

export function settingsForSpecificRevision(revisionId: number, config?: AxiosRequestConfig | undefined): Promise<Types.SettingsDto> {
    let url_ = getBaseUrl() + "/api/settings/revision/{revisionId}";
    if (revisionId === undefined || revisionId === null)
      throw new Error("The parameter 'revisionId' must be defined.");
    url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSettingsForSpecificRevision,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSettingsForSpecificRevision?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSettingsForSpecificRevision(_response);
    });
}

function processSettingsForSpecificRevision(response: AxiosResponse): Promise<Types.SettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSettingsDto(resultData200);
        return Promise.resolve<Types.SettingsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SettingsDto>(null as any);
}
let _requestConfigSettingsDto: Partial<AxiosRequestConfig> | null;
export function getSettingsDtoRequestConfig() {
  return _requestConfigSettingsDto;
}
export function setSettingsDtoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSettingsDto = value;
}
export function patchSettingsDtoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSettingsDto = patch(_requestConfigSettingsDto ?? {});
}

let _requestConfigSettingsForSpecificRevision: Partial<AxiosRequestConfig> | null;
export function getSettingsForSpecificRevisionRequestConfig() {
  return _requestConfigSettingsForSpecificRevision;
}
export function setSettingsForSpecificRevisionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSettingsForSpecificRevision = value;
}
export function patchSettingsForSpecificRevisionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSettingsForSpecificRevision = patch(_requestConfigSettingsForSpecificRevision ?? {});
}